import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { backendUrl } from "../../constants/config";

const LoginButton = () => {
  const navigate = useNavigate();

  const handleLoginSuccess = async (response) => {
    const decoded = jwtDecode(response.credential);
    const { name, email } = decoded;

    try {
      const resp = await axios.post(`${backendUrl}/user/loginUser`, { name, email });
      localStorage.setItem("TalentSyncUser", JSON.stringify(resp.data.user));

      if (resp.data.user.userType === "admin") {
        navigate("/admin-dashboard/home");
      } else if (resp.data.user.subscriptionBought) {
        navigate("/dashboard/gmailtrucker");
      } else {
        navigate("/apply");
      }
    } catch {
      alert("Login failed.");
    }
  };

  return (
    <GoogleLogin
      onSuccess={handleLoginSuccess}
      onError={() => alert("Google login failed")}
    />
  );
};

export default LoginButton;
